import { render } from "./ReportGroup.vue?vue&type=template&id=ba186baa"
import script from "./ReportGroup.vue?vue&type=script&lang=js"
export * from "./ReportGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__